<script>
import TheMixin from "../mixin/main.jtails";

export default {
  mixins: [ TheMixin ],
}
</script>
<!-- section template -->
<template>
  <div :class="$style.layout">
    <TheHeader v-if="isShowHeader"/>
    <div class="layout__body">
      <slot/>
    </div>
    <TheFooterJtails v-if="isShowFooter && $globalIsJtails"/>
    <TheFooterDingBeauty v-if="isShowFooter && $globalIsDingBeauty"/>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.layout {
  :global {
    .layout {
      &__body {
        padding-top: 80px;

        @include max-lg {
          padding-top: 67px;
        }

        @media (max-width: 860px) {
          padding-top: 60px;
        }
      }
    }
  }
}
</style>
